<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#e5f175" type="square-jelly-box" [fullScreen]="true">
  <p style="color: #e5f175">Cargando...</p>
</ngx-spinner>

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<notifier-container></notifier-container>

<main class="cert-shell">
  <section class="cert-header">
    <div class="cert-header-content">
      <h1>Aceptación de Seguro</h1>

      <div class="cert-header-meta" *ngIf="infoCert">
        <span>
          <i-feather name="user"></i-feather>
          {{ infoCert.first_name }} {{ infoCert.last_name }}
        </span>
        <span>
          <i-feather name="credit-card"></i-feather>
          {{ infoCert.identification_number }}
        </span>
      </div>
    </div>
  </section>

  <section *ngIf="infoCert && !aceptacion" class="cert-flow">
    <section class="info-panel">
      <div class="section-heading">
        <h2>Información del Crédito</h2>
      </div>

      <div class="detail-grid">
        <div class="detail-cell">
          <span>Fecha de Inicio</span>
          <strong>{{ infoCert.start_date | date:'yyyy-MM-dd' }}</strong>
        </div>
        <div class="detail-cell">
          <span>Fecha de Vencimiento</span>
          <strong>{{ infoCert.due_date | date:'yyyy-MM-dd' }}</strong>
        </div>
        <div class="detail-cell">
          <span>Número de Crédito</span>
          <strong>{{ infoCert.credit_number }}</strong>
        </div>
        <div class="detail-cell">
          <span>Tipo de Crédito</span>
          <strong>{{ infoCert.credit_type }}</strong>
        </div>
        <div class="detail-cell detail-cell--amount">
          <span>Monto del Crédito</span>
          <strong>{{ infoCert.credit_amount | currency }}</strong>
        </div>
        <div class="detail-cell">
          <span>Plazo</span>
          <strong>{{ infoCert.credit_term }}</strong>
        </div>
        <div class="detail-cell" *ngIf="infoCert.account_type">
          <span>Tipo de Cuenta</span>
          <strong>{{ infoCert.account_type }}</strong>
        </div>
      </div>
    </section>

    <section class="health-panel">
      <div class="section-heading">
        <h2>Enfermedades</h2>
      </div>

      <div class="health-grid">
        <div class="person-panel">
          <label class="question-label">¿Tiene alguna enfermedad?</label>
          <div class="choice-group">
            <label class="choice-pill" [class.choice-pill--active]="enfermedad === 'S'" for="enfermedadSi">
              <input class="choice-input" type="radio" name="enfermedad" id="enfermedadSi" value="S"
                [(ngModel)]="enfermedad" (change)="onEnfermedadChange('titular')">
              <span>Sí</span>
            </label>

            <label class="choice-pill" [class.choice-pill--active]="enfermedad === 'N'" for="enfermedadNo">
              <input class="choice-input" type="radio" name="enfermedad" id="enfermedadNo" value="N"
                [(ngModel)]="enfermedad" (change)="onEnfermedadChange('titular')">
              <span>No</span>
            </label>
          </div>

          <div *ngIf="enfermedad === 'S'" class="conditional-fields">
            <label for="observacion" class="field-label">Nombre de la enfermedad</label>
            <input id="observacion" type="text" class="field-input text-uppercase"
              placeholder="Ingrese una descripción de la enfermedad" [(ngModel)]="observacion"
              (input)="observacion = observacion?.toUpperCase()">

            <label for="dateTitular" class="field-label">Fecha de diagnóstico</label>
            <input id="dateTitular" type="date" [max]="today" class="field-input text-uppercase"
              [(ngModel)]="diagnosis_date">
          </div>
        </div>

        <div class="person-panel" *ngIf="infoCert.spouse_identification_number">
          <div class="person-heading">
            <span>Cónyuge</span>
            <strong>{{ infoCert.spouse_first_name }} {{ infoCert.spouse_last_name }}</strong>
          </div>

          <label class="question-label">¿Tiene alguna enfermedad el cónyuge?</label>
          <div class="choice-group">
            <label class="choice-pill" [class.choice-pill--active]="spouse_disease === 'S'" for="spouse_diseaseSi">
              <input class="choice-input" type="radio" name="spouse_disease" id="spouse_diseaseSi" value="S"
                [(ngModel)]="spouse_disease" (change)="onEnfermedadChange('conyugue')">
              <span>Sí</span>
            </label>

            <label class="choice-pill" [class.choice-pill--active]="spouse_disease === 'N'" for="spouse_diseaseNo">
              <input class="choice-input" type="radio" name="spouse_disease" id="spouse_diseaseNo" value="N"
                [(ngModel)]="spouse_disease" (change)="onEnfermedadChange('conyugue')">
              <span>No</span>
            </label>
          </div>

          <div *ngIf="spouse_disease === 'S'" class="conditional-fields">
            <label for="spouse_detail_disease" class="field-label">Nombre de la enfermedad</label>
            <input id="spouse_detail_disease" type="text" class="field-input text-uppercase"
              placeholder="Ingrese una descripción de la enfermedad" [(ngModel)]="spouse_detail_disease"
              (input)="spouse_detail_disease = spouse_detail_disease?.toUpperCase()">

            <label for="dateConyuge" class="field-label">Fecha de diagnóstico</label>
            <input id="dateConyuge" type="date" [max]="today" class="field-input text-uppercase"
              [(ngModel)]="spouse_diagnosis_date">
          </div>
        </div>
      </div>
    </section>

    <section class="document-panel">
      <div class="section-heading section-heading--between">
        <h2>Documentos</h2>
        <span class="document-count" *ngIf="pdfs?.length">
          {{ pdfs.length }} documento{{ pdfs.length === 1 ? '' : 's' }}
        </span>
      </div>

      <ng-container *ngIf="pdfs?.length">
        <div class="document-tabs" role="tablist" aria-label="Documentos generados">
          <button *ngFor="let p of pdfs; trackBy: trackById" type="button" class="document-tab"
            [class.document-tab--active]="activePdfId === p.id" (click)="setActivePdf(p.id)">
            <i-feather name="file-text"></i-feather>
            <span>{{ p.name }}</span>
          </button>
        </div>

        <div class="viewer-wrap">
          <ng-container *ngIf="activePdf?.base64?.length > 100; else noData">
            <div *ngIf="isMobile; else desktopViewer">
              <ngx-extended-pdf-viewer [id]="'viewer-' + activePdfId"
                [base64Src]="normalizedBase64(activePdf.base64 || '')" [showSidebarButton]="false"
                [useBrowserLocale]="true" [language]="'es-ES'" [height]="'80vh'" [zoom]="'page-width'"
                (pdfLoaded)="onPdfLoadMulti(activePdfId)" (pdfLoadingFailed)="onPdfErrorMulti(activePdfId)">
              </ngx-extended-pdf-viewer>

              <a [href]="activePdf.downloadUrl" target="_blank" rel="noopener" class="download-link">
                <i-feather name="download"></i-feather>
                Descargar / Abrir PDF
              </a>
            </div>

            <ng-template #desktopViewer>
              <div class="pdf-frame">
                <iframe [src]="activePdf.iframeUrl" title="Documento PDF: {{ activePdf.name }}" class="pdf-iframe"
                  allow="fullscreen" loading="lazy" (error)="onPdfErrorMulti(activePdfId)"
                  (load)="onPdfLoadMulti(activePdfId)">
                </iframe>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="!pdfs?.length && (pdfIframeUrl || singleBase64)">
        <div class="viewer-wrap">
          <div *ngIf="isMobile; else singleDesktop">
            <ngx-extended-pdf-viewer *ngIf="singleBase64" [base64Src]="singleBase64" [useBrowserLocale]="true"
              [language]="'es-ES'" [textLayer]="true" [showSidebarButton]="false" [height]="'80vh'"
              [zoom]="'page-width'">
            </ngx-extended-pdf-viewer>

            <a *ngIf="pdfDownloadUrl" [href]="pdfDownloadUrl" target="_blank" rel="noopener" class="download-link">
              <i-feather name="download"></i-feather>
              Descargar / Abrir PDF
            </a>
          </div>

          <ng-template #singleDesktop>
            <div class="pdf-frame" *ngIf="pdfSupported && pdfIframeUrl; else singleFallback">
              <iframe [src]="pdfIframeUrl" title="Documento PDF" class="pdf-iframe" allow="fullscreen" loading="lazy"
                (error)="onPdfError()" (load)="pdfSupported = true">
              </iframe>
            </div>
            <ng-template #singleFallback>
              <div class="inline-alert inline-alert--warning">
                <i-feather name="alert-triangle"></i-feather>
                <span>No se puede mostrar el PDF en este dispositivo.</span>
              </div>
              <a *ngIf="pdfDownloadUrl" [href]="pdfDownloadUrl" target="_blank" rel="noopener" class="download-link">
                <i-feather name="download"></i-feather>
                Descargar / Abrir PDF
              </a>
            </ng-template>
          </ng-template>
        </div>
      </ng-container>

      <div *ngIf="!submitted" class="inline-alert inline-alert--warning">
        <i-feather name="alert-triangle"></i-feather>
        <span>No hay PDF disponible para mostrar.</span>
      </div>
    </section>

    <div class="cert-actions">
      <button type="button" class="sign-button" (click)="saveandsign()" [disabled]="!submitted || isSaving"
        [attr.aria-busy]="isSaving">
        <i-feather *ngIf="!isSaving" name="check-circle"></i-feather>
        <span *ngIf="!isSaving">Firmar y Guardar</span>
        <span *ngIf="isSaving">
          <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
          Guardando...
        </span>
      </button>
    </div>
  </section>

  <section *ngIf="errorNotification" class="inline-alert inline-alert--info" role="alert">
    <i-feather name="alert-circle"></i-feather>
    <span>{{ errorNotificationMessage }}.</span>
  </section>

  <section *ngIf="aceptacion" class="success-state">
    <div class="success-content">
      <span class="success-icon" aria-hidden="true">
        <i-feather name="check"></i-feather>
      </span>
      <div>
        <div class="success-title-row">
          <h2>¡Todo listo, {{ infoCert?.first_name }} {{ infoCert?.last_name }}!</h2>
          <span class="status-pill status-pill--success">Aceptación registrada</span>
        </div>
        <p>Usted ya cuenta con una aceptación de seguro.</p>
      </div>
    </div>

    <div class="success-media">
      <img src="assets/images/gman2.png" alt="Aceptación registrada">
    </div>
  </section>

  <section *ngIf="!infoCert && !aceptacion" class="empty-state">
    <i-feather name="search"></i-feather>
    <span>No se encontraron datos para el número de crédito.</span>
  </section>

  <ng-template #noData>
    <div class="inline-alert inline-alert--warning">
      <i-feather name="alert-triangle"></i-feather>
      <span>No se pudo mostrar el PDF seleccionado.</span>
    </div>
  </ng-template>
</main>
